export enum PalletCondition {
    Undetermined = -1,
    Info = 0,
    ProducedNotinWarehouse = 1,
    InWarehouse = 2,
    Resorted = 3,
    Picked = 4,
    Delivered = 5,
    Scrapped = 6,
    PutAwayviaStorageUnitList = 7,
    Lost = 8,
    Deleted = 9,
    StockTransfer = 10,
    Intermediatepallet = 11,
    QualityInspection = 12,
    BlockedResort = 13,
    AllocatedforDelivery = 94,
    LabelPrinted = 99
}
